<template>
<div class="mt-5">
  <div class="wrap mt-5">
    <div class="d-flex flex-column align-items-center cards" style="max-width:1000px">
      <h4 class="tit1 text-primary mr-0 text-center">測試收銀台</h4>
      <div class="row inputWrap">
        <div class="col-12 d-flex liss border-b">
          <h6 class="text-right d-flex flex-wrap-wrap h6T align-items-center">
            <p class="text-primary">訂單金額</p>
            <input type="text" placeholder="訂單金額" v-model="amount_total">
          </h6>
        </div>
        <div class="col-12  liss border-b">
          <h6 class="text-right d-flex flex-wrap-wrap h6T align-items-center">
            <p class="text-primary">用戶名稱</p>
            <input type="text" placeholder="用戶名稱" v-model="user_name">
          </h6>
        </div>
        <div class="col-12 d-flex liss border-b">
          <h6 class="text-right d-flex flex-wrap-wrap h6T">
            <div>
              <p class="text-primary">支付方式</p>
            </div>
            <div class="payWrap">
              <div class="pay" :class="{'active' : pay_channel_id == list.pay_channel_id}" @click="pay_channel_id = list.pay_channel_id ; type=list.type" v-for="(list) in payChannel" :key="list.pay_channel_id">
                <div class="payContent">
                  <p class="title text-left">{{list.pay_channel_name.split('-')? list.pay_channel_name.split('-')[0] : list.pay_channel_name}}</p>
                  <p class="text-center mt-2">{{list.pay_channel_name.indexOf('-')!=-1 ? list.pay_channel_name.substring(list.pay_channel_name.indexOf('-')):list.pay_channel_name}}</p>
                </div>
              </div>
            </div>
          </h6>
        </div>
      </div>
      <button class="btn send mt-4" @click="send">立即支付</button>
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.allWrap {
  justify-content: center;
}

.send {
  width: 200px;
  height: 40px;
  background-color: #0f73eb;
  color: white
}

.imgWrap {
  display: flex;
  flex-direction: column;

  img {
    max-width: 1000px;
    width: 100%;
  }
}

body {
  background-color: #ebeff0 !important;
}

.wrap {
  font-family: 新細明體 !important;
  width: 100%;
  min-height: 90vh;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}

p {
  color: black;
  font-size: 16px;
  word-break: break-all;
}

.cards {
  width: 100%;
  background-color: #fff;
  display: block;
  padding: 30px 50px;
  border-radius: 10px;
  margin-bottom: 30px;
}

.liss:nth-child(even) {
  // justify-content: flex-end;
}

.liss:nth-child(even) {
  justify-content: flex-start !important;

  h6 {
    // justify-content: space-between !important;
    width: 100%;
    flex-direction: row !important;
    align-items: center;
  }
}

.h6T {
  // justify-content: space-between !important;
  width: 100%;

  // flex-direction: column;
  p {
    // text-align: left;
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .liss:nth-child(even) {
    justify-content: flex-start !important;

    h6 {
      justify-content: space-between !important;
      width: 100%;
      flex-direction: row !important;
    }
  }

  .h6T {
    justify-content: space-between !important;
    width: 100%;

    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }

  .cards {
    padding: 20px;
  }
}

.tit1 {
  margin-bottom: 30px;
  border-bottom: 3px solid #007bff;
  padding-bottom: 20px;
}

h6 {
  // line-height: 2;
}

.inputWrap {
  // border-top: 3px solid #ccc;
  // border-bottom: 3px solid #ccc;
}

.border-b {
  width: 100%;
  border-bottom: 1px solid #ccc;

  p {
    &:first-child {
      width: 200px;
      text-align: left;
    }
  }
}

.btn {
  padding: 5px;
  border-radius: 5px;
  min-width: 80px;
  color: white;
  background-color: #4669e7;
  float: right;
  margin-bottom: 5px;

  &:hover {
    color: white;
  }
}

.lanWrap {
  display: flex;
  justify-content: flex-end;

  .lanBox {
    padding: 3px 5px;
    border: 1px solid black;
    border-radius: 3px;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;

    &.active {
      color: white;
      background-color: #4669e7;
      border: 1px solid gray;
    }
  }
}

.t1 {
  text-align: center;
}

.t2 {
  text-align: right;
}

@media (max-width: 500px) {
  .t1 {
    text-align: left;
  }

  .t2 {
    text-align: center;
  }

  .tit1 {
    font-size: 24px;
  }

  .border-b {
    flex-wrap: wrap;

    p {
      &:first-child {
        width: 150px;
      }
    }

    p {
      &:last-child {
        padding-left: 0 !important;
      }
    }
  }
}

@media (max-width: 400px) {
  .t1 {
    text-align: left;
  }

  .t2 {
    text-align: center;
  }

  .tit1 {
    font-size: 24px;
  }

  .border-b {
    flex-wrap: wrap;

    p {
      &:first-child {
        width: 100px;
      }
    }

    p {
      &:last-child {
        padding-left: 0 !important;
      }
    }
  }
}

.noQrcode {
  width: 150px;
  margin-top: -20px;
}

input {
  width: 245px;
  height: 40px;
  padding: 10px;
  border-color: #e6e6e6;
  border-width: 2px;
  appearance: none;
  outline: none;

  &:focus {
    border-color: #0f73eb;
  }
}

.rightCC {
  // padding-top: 10px;
  // padding-bottom: 10px;
}

.liss {
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 75px;
  align-items: center;
}

.payWrap {
  display: flex;
  flex-wrap: wrap;
  // justify-content: flex-end;
}

.pay {
  margin-right: 10px;
  font-size: 14px;
  width: 200px;
  height: 100px;
  border: 1px solid #e6e6e6;
  padding: 15px;
  margin-bottom: 10px;
  cursor: pointer;

  &.active {
    border-color: #0f73eb;
  }
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      order: {},
      pay_channel_id: "",
      pay_product_name: " Vip基礎服務",
      type: "",
      payChannel: [
        // {
        //     "pay_channel_id": "8643959b-aa55-425a-9ce5-d669d94ccc81",
        //     "pay_channel_name": "50010-聯邦銀行-50009-收款",
        //     "type": 0
        // },
      ],
      user_name: "",
      amount_total: "",
      method: false,
      payMethod: "",
      msg: "",
      bank_id: "",
      member_id: "",
      remark: "",
    };
  },
  methods: {
    send() {
      let data = {};
      if (Object.keys(this.$route.query).indexOf("mid") != -1) {
        data = {
          amount_total: this.amount_total,
          pay_channel_id: this.pay_channel_id,
          user_name: this.user_name,
          // pay_product_name: this.pay_product_name,
          type: this.type,
          bank_id: this.bank_id,
          member_id: this.member_id,
          remark: this.remark,
        };
      } else {
        data = {
          amount_total: this.amount_total,
          pay_channel_id: this.pay_channel_id,
          user_name: this.user_name,
          // pay_product_name: this.pay_product_name,
          type: this.type,
          bank_id: this.bank_id,
          member_id: this.member_id,
          remark: this.remark,
        };
      }
      if (
        this.$route.name == "demo_code" ||
        this.$route.name == "demo_member"
      ) {
        data = {
          amount_total: this.amount_total,
          pay_channel_id: this.pay_channel_id,
          user_name: this.user_name,
          // pay_product_name: this.pay_product_name,
          type: this.type,
          bank_id: this.bank_id,
          member_id: this.member_id,
          remark: this.remark,
        };
      }
      Object.keys(data).forEach((e) => {
        if (data[e] === "") {
          delete data[e];
        }
      });
      axios
        .post(`${process.env.VUE_APP_DEFAULT_SRC}/ccc/order`, data)
        .then((res) => {
          if (res.data.code == 0) {
            if (
              res.data.data &&
              res.data.data.message &&
              res.data.data.message == "Server Error"
            ) {
              this.msg = "未知錯誤,請聯繫技術";
            }
            if (res.data.data.view_url) {
              window.location.href = res.data.data.view_url;
            } else {
              // res.data.data.view_url == null
              this.payMethod = 1;
              axios
                .get(
                  `${process.env.VUE_APP_DEFAULT_SRC}/ccc/query?transaction_id=${res.data.data.transaction_id}`
                )
                .then((res) => {
                  if (res.data.code == 0) {} else {}
                });
            }
          } else {
            alert(res.data.message);
          }
        });
    },
  },
  created() {
    this.msg = "";
    if (Object.keys(this.$route.query).indexOf("mid") != -1) {
      this.pay_product_name = "商戶內充單";
    } else {
      this.pay_product_name = "玩家充值單";
    }
    if (Object.keys(this.$route.query).indexOf("mid") != -1) this.method = true;
    if (this.$route.name == "demo_code" || this.$route.name == "demo_member") {
      this.method = true;
    }
    if (this.$route.name == "demo_code" || this.$route.name == "demo_member") {
      this.pay_product_name = "管理員測試單";
    }
    // this.pay_product_name = 123;
    axios
      .post(`${process.env.VUE_APP_DEFAULT_SRC}/ccc/list`, this.$route.query)
      .then((res) => {
        if (res.data.code == 0) {
          this.payChannel = res.data.data;
          this.pay_channel_id = res.data.data[0].pay_channel_id;
          this.type = res.data.data[0].type;
        } else {
          alert(res.data.message);
        }
      });
  },
};
</script>
